import { useRef } from 'react';
import { useRouter } from 'next/router';

import { Field, Text, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';

import { SitecoreContextValue } from 'src/lib/ComponentProps';

import { SocialSharingOptions } from 'src/types/SocialSharingOptions';

import EmailIconSvg from 'public/icons/Email.svg';
import FacebookIconSvg from 'public/icons/facebook.svg';
import InstagramIconSvg from 'public/icons/instagram.svg';
import LinkedinIconSvg from 'public/icons/linkedin.svg';

import styles from './ShareOptions.module.css';

type ShareOptionsProps = {
	shareTitle?: string;
	shareUrl?: string;
	shareOptions: SocialSharingOptions;
	noShareOptions?: Field<string>;
};

export default function ShareOptions(props: ShareOptionsProps): JSX.Element {
	const { sitecoreContext } = useSitecoreContext<SitecoreContextValue>();
	const router = useRouter();

	const svgs = useRef<{ [key: string]: JSX.Element }>({
		email: <EmailIconSvg />,
		facebook: <FacebookIconSvg />,
		instagram: <InstagramIconSvg />,
		linkedin: <LinkedinIconSvg />,
	});

	const formatHref = (string: string) => {
		return string
			.replaceAll('$title$', props.shareTitle || (sitecoreContext?.route?.fields?.PageTitle?.value as string))
			.replaceAll('$url$', props.shareUrl || process.env.PUBLIC_URL + router.asPath);
	};

	return props.shareOptions && props.shareOptions.length > 0 ? (
		<ul className={styles.shareOptionsContainer}>
			{props.shareOptions.map(({ fields: { Href, AltText }, name }, index) => {
				return (
					<li key={`share-option-${index}`}>
						<a
							href={formatHref(Href.value)}
							className={`${styles.shareOptionsItems} noExternalSiteIcon`}
							title={AltText.value}
							target="_blank"
							rel="noreferrer"
						>
							<span className={styles.shareOptionsIcon}>{svgs.current[name.toLowerCase()]}</span>
						</a>
					</li>
				);
			})}
		</ul>
	) : (
		<Text tag="span" field={props.noShareOptions} className={styles.noShareOptions} />
	);
}
